import * as Types from '../generated/types';

import { gql } from '@apollo/client';
export type AuthUserNodeFragment = { __typename?: 'AuthUserNode', id: string, username: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, isStaff: boolean, isActive: boolean, isReadOnly: boolean };

export const AuthUserNodeFragmentDoc = gql`
    fragment AuthUserNode on AuthUserNode {
  id
  username
  firstName
  lastName
  fullName
  email
  isStaff
  isActive
  isReadOnly
}
    `;